import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=31a0a324&scoped=true&"
import script from "./BatchUpload.vue?vue&type=script&lang=ts&"
export * from "./BatchUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0a324",
  null
  
)

export default component.exports